import React from 'react'
import styles from './DataTableCell.module.scss'

type Align = 'left' | 'center' | 'right'

interface DataTableCellProps {
  children: React.ReactNode
  align?: Align
  className?: never
}

const alignMap: Record<Align, string> = {
  left: styles.left, center: styles.center, right: styles.right,
}

export const DataTableCell: React.FC<DataTableCellProps> = ({
  children, align = 'left',
}) => (
  <td className={[styles.cell, alignMap[align]].join(' ')}>{children}</td>
)
